import BrandCard from "./BrandCard";
import { Typography, useTheme, Box } from "@mui/material";
import React, { useRef, useEffect } from "react";

function BrandContainer(props) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const scrollRef = useRef(null);

  const brands = props.brands || [];
  const displayedBrands = [...brands, ...brands]; // duplicate for continuous scroll

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const step = 2;
    let animationId;
    let isPaused = false; // 👈 hover flag

    const animate = () => {
      if (!isPaused) {
        scrollPosition += step;
        if (scrollPosition >= scrollContainer.scrollWidth / 2) {
          scrollPosition = 0;
        }
        scrollContainer.scrollLeft = scrollPosition;
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    // 👇 pause on hover
    const handleMouseEnter = () => {
      isPaused = true;
    };
    const handleMouseLeave = () => {
      isPaused = false;
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationId);
      scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <Box
      sx={{
        mt: { xs: 3, sm: 4, md: 5 },
        mb: { xs: 3, sm: 4, md: 5 },
        px: { xs: 1, sm: 1, md: 0 },
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: 1,
          fontSize: { xs: "1rem", sm: "1.2rem" },
          color: theme.palette.primary.main,
          overflow: "hidden",
        }}
      >
        {props.heading}
      </Typography>

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          gap: 0,
          overflowX: "hidden",
          alignItems: "center",
        }}
      >
        {displayedBrands.map((data, index) => (
          <Box key={index} sx={{ minWidth: 200 }}>
            <BrandCard data={data} primaryColor={primaryColor} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default BrandContainer;
